module.exports = __webpack_public_path__ + "static/media/Group73.dff59e9f.png";